export default import.meta.ROLLDOWN_FILE_URL_gcTo8z7eTh1bxVn0WgfmDA